import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from './types/Conversation';
import { APIV2_URL } from './constants';

export interface Payload {
  listingId: number;
  startDate: string;
  endDate: string;
  messageText: string;
  instantBooking?: boolean;
  adProvider?: string;
  adClickID?: string;
  bookingLink?: boolean;
}

interface ConversationFeatureFlags {
  rentalConditions?: boolean;
  bookingLink?: boolean;
  tenantSubscriptions?: boolean;
}

type FeatureFlagHeaders =
  | 'rentalConditions'
  | 'bookingLink'
  | 'tenantSubscriptions';

export default (makeCall: MakeCall) =>
  (data: Payload, featureFlags?: ConversationFeatureFlags) => {
    const features: FeatureFlagHeaders[] = [];
    if (featureFlags?.rentalConditions) {
      features.push('rentalConditions');
    }
    if (featureFlags?.bookingLink) {
      features.push('bookingLink');
    }
    if (featureFlags?.tenantSubscriptions) {
      features.push('tenantSubscriptions');
    }

    const headers =
      features.length > 0 ? { 'X-HA-Features': features.join(';') } : {};

    return makeCall<Conversation>('POST', `${APIV2_URL}/conversation`, {
      data,
      headers,
    });
  };
